
import React from 'react';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

// copied from react-countdown-clock
//https://github.com/pughpugh/react-countdown-clock/blob/master/coffee/react-countdown-clock.coffee


const MyCountdownClock = CreateReactClass({
  _seconds: 0,
  _radius: null,
  _fraction: null,
  _content: null,
  _canvas: null,
  _timeoutIds: [],
  _start: 0,
  _scale: window.devicePixelRatio || 1,
  _midCallComplete: false,
  _frameID: 0,

  component: React.createRef(),
  background: React.createRef(),
  timer: React.createRef(),

  displayName: 'MyCountdownClock',

  componentDidUpdate(prevProps) {
    if (prevProps.seconds !== this.props.seconds ||
      prevProps.timerCount !== this.props.timerCount) {
      this._seconds = this._startSeconds();
      this._stopTimer();
      this._setupTimer();
      if (prevProps.seconds !== this.props.seconds) {
        console.log('timer reseseconds changedt in update')
      }
      if (prevProps.timerCount !== this.props.timerCount) {
        console.log('timer count changedt in update')
      }
    }

    if (prevProps.color !== this.props.color) {
      this._drawBackground();
      this._updateCanvas();
    }

    if (prevProps.paused !== this.props.paused) {
      if (!this.props.paused) { this._startTimer(); }
      if (this.props.paused) { return this._pauseTimer(); }
    }
  },

  componentDidMount() {
    console.log('timer mounted')
    this._seconds = this._startSeconds();
    return this._setupTimer();
  },

  componentWillUnmount() {
    return this._cancelTimer();
  },

  _startSeconds() {
    // To prevent a brief flash of the start time when not paused
    // took away 1 second to stop the 0 countdonwwn
    //if (this.props.paused) { return this.props.seconds; } else { return this.props.seconds - 0.01; }
    if (this.props.paused) { return this.props.seconds; } else { 
      // we want to remove network latency from the remaining time
      /* WE HAVE ADJUSTED IN THE PARENT
      let serverEndTime=this.props.startTimeAtOrigin + (this.props.seconds * 1000);
      let currentDate=Date.now();
      let ourAdjustedTime=currentDate+this.props.clockOffset;
      let newElapsedPeriod=(serverEndTime-ourAdjustedTime)/1000;
      return newElapsedPeriod - 0.01; 
      */
      return this.props.seconds - 0.0001;
    }
  },

  _setupTimer() {
    this._setScale();
    this._setupCanvases();
    this._drawBackground();
    this._drawTimer();
    if (!this.props.paused) { return this._startTimer(); }
  },

  _updateCanvas() {
    this._clearTimer();
    return this._drawTimer();
  },

  _setScale() {
    this._radius      = this.props.size / 2;
    this._fraction    = 2 / this._seconds;
    this._tickPeriod  = this._calculateTick();
    return this._innerRadius =
      this.props.weight ?
        this._radius - this.props.weight
      :
        this._radius / 1.8;
  },

  _calculateTick() {
    // Tick period (milleseconds) needs to be fast for smaller time periods and slower
    // for longer ones. This provides smoother rendering. It should never exceed 1 second.
    const tickScale = 1.8;
    const tick = this._seconds * tickScale;
    if (tick > 1000) { return 1000; } else { return tick; }
  },

  _setupCanvases() {
    if (this._background && this._timer) { return; }

    this._background = this.background.current.getContext('2d');
    this._background.scale(this._scale, this._scale);

    this._timer = this.timer.current.getContext('2d');
    this._timer.textAlign = 'center';
    this._timer.textBaseline = 'middle';
    this._timer.scale(this._scale, this._scale);

    if (this.props.onClick != null) {
      return this.component.current.addEventListener('click', this.props.onClick);
    }
  },

  _startTimer() {
    this._start = Date.now();
    this._origSeconds = this._seconds;
    this._frameID = window.requestAnimationFrame(this._tick);
  },

  _pauseTimer() {
    this._stopTimer();
    return this._updateCanvas();
  },

  _stopTimer() {
      window.cancelAnimationFrame(this._frameID);
      return Array.from(this._timeoutIds).map((timeout) =>
        clearTimeout(timeout));
    
  },

  _cancelTimer() {
    this._stopTimer();

    if (this.props.onClick != null) {
      return this.component.current.removeEventListener('click', this.props.onClick);
    }
  },
  /**
   * _tick() {
    const start = Date.now();
    return this._timeoutIds.push(setTimeout(( () => {
      const duration = (Date.now() - start) / 1000;
      this._seconds -= duration;
      
      if ( ! this._midCallComplete && this._seconds <= this.props.midcallSeconds) {
        this._midCallComplete = true;
        this._handleMidcall();
      }

      if (this._seconds <= 0) {
        this._seconds = 0;
        this._handleComplete();
        return this._clearTimer();
      } else {
        this._updateCanvas();
        return this._tick();
      }
    }
    ), this._tickPeriod));
  },
   */

  _tick() {

      let remainingTime;
      if (this.props.endTimeMs && this.props.getAdjustedNowMs) {
        // Recompute from absolute end time on every frame — immune to render-cycle delay and clock drift
        remainingTime = (this.props.endTimeMs - this.props.getAdjustedNowMs()) / 1000;
      } else {
        remainingTime = this._origSeconds - ((Date.now() - this._start) / 1000);
      }
      this._seconds = remainingTime;
      
      if ( ! this._midCallComplete && this._seconds <= this.props.midcallSeconds) {
        this._midCallComplete = true;
        this._handleMidcall();
      }

      if (this._seconds <= 0) {
        window.cancelAnimationFrame(this._frameID);
        this._seconds = 0;
        this._handleComplete();
        return this._clearTimer();
      } else {
        this._updateCanvas();
        this._frameID = window.requestAnimationFrame(this._tick);
            //return this._tick();
      }
    
  },

  _handleComplete() {
    if (this.props.onComplete) {
      return this.props.onComplete();
    }
  },

  _handleMidcall() {
    if (this.props.onMidcall) {
      return this.props.onMidcall();
    }
  },

  _clearBackground() {
    return this._background.clearRect(0, 0, this.timer.current.width, this.timer.current.height);
  },

  _clearTimer() {
    if (this.timer.current != null) {
      return this._timer.clearRect(0, 0, this.timer.current.width, this.timer.current.height);
    }
  },

  _drawBackground() {
    this._clearBackground();
    this._background.beginPath();
    this._background.globalAlpha = this.props.alpha / 3;
    this._background.fillStyle = this.props.color;
    this._background.arc(this._radius, this._radius,      this._radius,           0, Math.PI * 2, false);
    this._background.arc(this._radius, this._radius, this._innerRadius, Math.PI * 2,           0, true);
    this._background.closePath();
    return this._background.fill();
  },

  _formattedTime() {
    let left;
    // add one to myseconds to compensate for removing in the timer
    // the display should not know about it
    
    let _mySeconds=this._seconds;
    const decimals = ((left = (_mySeconds < 10) && this.props.showMilliseconds)) != null ? left : {1 : 0};
    if (this.props.timeFormat === 'hms') {
      let seconds;
      const hours   = parseInt( _mySeconds / 3600 ) % 24;
      const minutes = parseInt( _mySeconds / 60 ) % 60;
//console.log('parseInt=', _mySeconds, _mySeconds / 60, parseInt( _mySeconds / 60 ), parseInt( _mySeconds / 60 ) % 60)

      if (decimals) {
        seconds = ((Math.floor(_mySeconds * 10) / 10)).toFixed(decimals);
      } else {
        seconds = Math.floor(_mySeconds % 60);
      }

      let hoursStr = `${hours}`;
      let minutesStr = `${minutes}`;
      let secondsStr = `${seconds}`;

      if (hours < 10) { hoursStr   = `0${hours}`; }
      if ((minutes < 10) && (hours >= 1)) { minutesStr = `0${minutes}`; }
      if ((seconds < 10) && ((minutes >= 1) || (hours >= 1))) { secondsStr = `0${seconds}`; }

      const timeParts = [];
      let timePartsStr = "";
      /**
       * if (hours > 0) { timeParts.push(hoursStr); }
        if ((minutes > 0) || (hours > 0)) { timeParts.push(minutesStr); }
        timeParts.push(secondsStr);
       */
      if (hours > 0) { timePartsStr=hoursStr+":"}
      if ((minutes > 0) || (hours > 0)) { 
        timePartsStr = timePartsStr + minutesStr+":"; 
      }
        timePartsStr = timePartsStr + secondsStr; 

      return timePartsStr;
    } else {
      return (Math.floor(_mySeconds * 10) / 10).toFixed(decimals);
    }
  },

  _fontSize(timeString) {
    if (this.props.fontSize === 'auto') {
      const scale = (() => { switch (timeString.length) {
        case 8: return 4; // hh:mm:ss
        case 5: return 3; // mm:ss
        default: return 2;        // ss or ss.s
      } })();
      const size = this._radius / scale;
      return `${size}px`;
    } else {
      return this.props.fontSize;
    }
  },

  _drawTimer() {
    const percent = (this._fraction * this._seconds) + 1.5;
    
    const formattedTime = this._formattedTime();
 //console.log(formattedTime)
    const text = (this.props.paused && (this.props.pausedText != null)) ? this.props.pausedText : formattedTime;

    // Timer
    this._timer.globalAlpha = this.props.alpha;
    this._timer.fillStyle = this.props.color;
    this._timer.font = `bold ${this._fontSize(formattedTime)} ${this.props.font}`;
    this._timer.fillText(text, this._radius, this._radius);
    this._timer.beginPath();
    this._timer.arc(this._radius, this._radius, this._radius,      Math.PI * 1.5,     Math.PI * percent, false);
    this._timer.arc(this._radius, this._radius, this._innerRadius, Math.PI * percent, Math.PI * 1.5,     true);
    this._timer.closePath();
    return this._timer.fill();
  },

  render() {
    const canvasStyle = { position: 'absolute', width: this.props.size, height: this.props.size };
    const canvasProps = { style: canvasStyle, height: this.props.size * this._scale, width: this.props.size * this._scale };

    return <div ref={this.component} className="react-countdown-clock" style={{width: this.props.size, height: this.props.size}}>
      <canvas ref={this.background} {...canvasProps}></canvas>
      <canvas ref={this.timer} {...canvasProps}></canvas>
   
    </div>;
  }
});

MyCountdownClock.propTypes = {
  seconds: PropTypes.number,
  endTimeMs: PropTypes.number,
  getAdjustedNowMs: PropTypes.func,
  midcallSeconds: PropTypes.number,
  size: PropTypes.number,
  weight: PropTypes.number,
  color: PropTypes.string,
  fontSize: PropTypes.string,
  font: PropTypes.string,
  alpha: PropTypes.number,
  timeFormat: PropTypes.string,
  onComplete: PropTypes.func,
  onMidcall: PropTypes.func,
  onClick: PropTypes.func,
  showMilliseconds: PropTypes.bool,
  paused: PropTypes.bool,
  pausedText: PropTypes.string
};

MyCountdownClock.defaultProps = {
  seconds: 60,
  midcallSeconds: 0,
  size: 300,
  color: '#000',
  alpha: 1,
  timeFormat: 'hms',
  fontSize: 'auto',
  font: 'Arial',
  showMilliseconds: true,
  paused: false
};

export default MyCountdownClock;
